import { MIN_YEAR_PERENCANAAN_V2 } from 'app/KinerjaPSPegawaiPage/constants/perencanaan'

/**
 * Check if selected year period should use perencanaan V2 UI
 * @param periodYear - Selected year period
 * @returns A boolean indicating selected year period should use perencanaan V2 UI
 */
export const isPerencanaanV2 = (periodYear: number) =>
  periodYear >= MIN_YEAR_PERENCANAAN_V2
